import {
  isAddressComponent,
  isDateComponent,
  isDateRangeComponent,
  isEmailComponent,
  isFileComponent,
  isGeolocationComponent,
  isNumberComponent,
  isPersonComponent,
  isRelatedCardComponent,
  isRelatedCardLookupComponent,
  isSignatureComponent,
  isSubformComponent,
  isTagComponent,
  isTextComponent,
  isTodoComponent,
  isUrlComponent,
} from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';

/** The collection table's fixed width for a column of this field type. */
export function getColumnWidth(component: API.AnyComponent) {
  if (isNumberComponent(component)) {
    return 200;
  }
  if (isTagComponent(component) && component.multiselect) {
    return 300;
  }
  if (isTagComponent(component) && !component.multiselect) {
    return 300;
  }
  if (isAddressComponent(component)) {
    return 300;
  }
  if (isDateComponent(component)) {
    return 220;
  }
  if (isDateRangeComponent(component)) {
    return 220;
  }
  if (isEmailComponent(component)) {
    return 300;
  }
  if (isFileComponent(component)) {
    return 200;
  }
  if (isGeolocationComponent(component)) {
    return 300;
  }
  if (isPersonComponent(component)) {
    return 300;
  }
  if (isRelatedCardComponent(component)) {
    return 300;
  }
  if (isRelatedCardLookupComponent(component)) {
    return 300;
  }
  if (isSignatureComponent(component)) {
    return 220;
  }
  if (isSubformComponent(component)) {
    return 300;
  }
  if (isTextComponent(component)) {
    return 300;
  }
  if (isTodoComponent(component)) {
    return 300;
  }
  if (isUrlComponent(component)) {
    return 300;
  }
  return 300;
}
